import { ColorEnum } from '@/constants/color'
import Item from '@/features/settings/components/PrintManagement/components/Item'
import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

const EmptyPrinterItem: FC = () => {
    const { t } = useTranslation()

    return (
        <Item>
            <PrinterIcon width="32" height="32" fill={ColorEnum.BRICK_600} />
            <Typography.Heading variant="h3">
                {t('settings.printers.printManagement.noPrinters.heading')}
            </Typography.Heading>
            <Typography.Description style={styles.description}>
                {t('settings.printers.printManagement.noPrinters.description')}
            </Typography.Description>
        </Item>
    )
}

const styles = StyleSheet.create({
    description: {
        color: ColorEnum.GRAY_600,
    },
})

export default EmptyPrinterItem
